export default __webpack_public_path__ + "static/media/placeholder_store05-en-mobile.52968dab.png";